import React from "react";
import "../css-coding/OurBrandMantraPage.css";

// Icons
const MapPinIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none"
       stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/>
    <circle cx="12" cy="10" r="3"/>
  </svg>
);

const MailIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none"
       stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect width="20" height="16" x="2" y="4" rx="2"/>
    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
  </svg>
);

const GlobeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none"
       stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"/>
    <path d="M2 12h20"/>
  </svg>
);

const InstagramIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none"
       stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect width="20" height="20" x="2" y="2" rx="5" ry="5"/>
    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
    <line x1="17.5" x2="17.51" y1="6.5" y2="6.5"/>
  </svg>
);

// Data
const notableClients = [
  "Kennet Alphy - Co-founder of The Goat Media",
  "Explore with Ephaphra - Founder of Townscholar",
  "Sharan Rajkumar - Founder of Dike Digital Media",
  "Aswin Ashtaglearns - Founder of Ashtag",
  "Sangeetha S Abhishek - Founder of Sodme",
];

const otherClients = [
  "Magadoo", "Donington", "Udhyam Builders", "Ecologic Ads", "MD Beauty Academy",
  "OnArrive", "Aiswaryam Oils", "Skill Rain", "KTG", "Saibariya Skin & Haircare",
  "Subramanya College", "SYNO", "Gold Star Inners", "GKrishna Naturals",
  "Liku Boutique", "A1 Bricks", "Skanda Corp", "Heartfulness"
];

// Contact Info Component
const ContactInfo = () => (
  <div className="contact-info">
    {/* <p className="sub-heading-mv-2010">The Growth Secret Media</p>
    <p className="sub-heading-mv-201">Where Growth Meets Success</p>
    <br></br> */}

    <div className="contact-list">
      <div className="contact-item-2">
        <MapPinIcon /> <span>Coimbatore, Tamil Nadu, India</span>
      </div>

      <div className="contact-item-2">
        <MailIcon />
        <a href="mailto:contact@thegrowthsecret.in">contact@thegrowthsecret.in</a>
      </div>

      <div className="contact-item-2">
        <GlobeIcon />
        <a href="https://thegrowthsecret.in" target="_blank" rel="noopener noreferrer">thegrowthsecret.in</a>
      </div>

      <div className="contact-item-2">
        <InstagramIcon />
        <span>Follow us: <a href="https://instagram.com/thegrowthsecretmedia" target="_blank">@thegrowthsecretmedia</a></span>
      </div>
    </div>
  </div>
);

// Main Component
const ClientPortfolioPage = () => {
  return (
    <div className="portfolio-page">
     
     
      <section className="portfolio-section">
         <h2 className="main-title-cu-2">Our Brand Mantra</h2>
             <h3 className="sub-heading-mv-2">Creativity, Consistency, Community</h3>
              <p className="intro-text-mv-2">At The Growth Secret Media, our brand mantra revolves around three core
principles:</p>
<br></br>
<br/>
 <p className="intro-text-mv-2"><b>Creativity:</b> We believe that creativity is the input that transforms ordinary
content into extraordinary experiences. Every project starts with a creative
spark that we nurture and develop into compelling visual stories.</p>
<br>
</br>
<br/>
 <p className="intro-text-mv-2"><b>Consistency:</b> Creativity without consistency is just a one-time wonder. We
maintain consistent quality, delivery schedules, and communication standards
across all our projects. This consistency builds trust and reliability.</p>
<br>
</br>
<br/>
 <p className="intro-text-mv-2"><b>Community:</b> Consistent, creative work builds a strong community around your
brand. This community becomes your most valuable asset, supporting your
growth and amplifying your message across digital platforms.</p>
<br/>
<br/>

 <p className="intro-text-mv-2">This interconnected approach ensures that our creative input leads to
consistent output, which in turn creates a lasting impact among your target
community.</p>
<br/>
<br/>
<br/>
<br/>
<br/>
<br/>



        {/* <h2 className="main-title-cu-201">Our Prestigious Client Portfolio</h2>
        <br></br>  <br></br>  
        <p className="intro-text-mv-2">
          We've had the privilege of working with industry leaders and rising stars across various sectors:
        </p>

        <h3 className="sub-heading-mv-2">Notable Clients Include:</h3>
        <ul className="client-list-22">
          {notableClients.map((client, i) => (
            <li key={i}>
              <strong>{client.split(" - ")[0]}</strong> - <span className="client-role">{client.split(" - ")[1]}</span>
            </li>
          ))}
        </ul>

        <p className="other-clients">{otherClients.join(", ")}, and many more.</p>
        <br></br><br></br>
        <p className="other-clients">
          Each client relationship is a testament to our commitment to excellence and
our ability to deliver results that drive business growth.
        </p>
   
      <br></br>
      <br></br>
      <br></br> */}

         </section>

      {/* Difference Section */}
      <section className="difference-section">
        <h2 className="main-title-cu-201">The Growth Secret Difference</h2>
        <br/>
          <br/>
            
<p className="intro-text-mv-2">
           What sets us apart isn't just our technical expertise or our impressive client
roster - it's our approach to partnership. We don't just provide services; we
become an extension of your team, invested in your success and committed to
helping you achieve your goals.
        </p>
        <br/>
          <br/>

        <p className="intro-text-mv-2">
     Our journey from two passionate individuals to a recognized MSME company
is a testament to the power of creativity, consistency, and community. We've
applied these same principles to help our clients grow their brands, increase
their engagement, and achieve their business objectives.
        </p>
          <br/>
            <br/>

           <p className="intro-text-mv-2">
    At The Growth Secret Media, we believe that every frame tells a story, and
every story has the power to transform businesses and lives. Let us help you
tell your story in the most compelling way possible.
        </p>
          <br/>
            <br/>
            <br></br>

              <p className="intro-text-mv-2">
<b>Ready to unlock your growth secret?</b> Contact us today and let's create
something extraordinary together.
        </p>
      
        
           



        <div className="cta-box">
          

          <ContactInfo />
        </div>
      </section>
    </div>
  );
};

export default ClientPortfolioPage;
